<template>
<div id="id_guild_ranking_container">

        <div class="columns is-vcentered is-centered">
            <div class="column is-12-mobile is-4 clickeable-box" @click="goToDetail(top3[0].name)">
                <div class="box has-text-grey back-gold">
                    <div class="media">
                        <div class="media-left">
                            <figure class="image is-64x64">
                                <fa icon="trophy" class="gold-color fa-4x"/>
                            </figure>
                        </div>
                        <div class="media-content has-text-centered is-clipped has-text-justified-mobile">
                            <p class="is-size-3-widescreen is-size-4-touch is-size-4-desktop has-text-grey is-marginless">  
                                <b>{{top3[0].name}}</b>
                            </p>
                            <p class="is-size-4 is-size-5-touch has-text-grey is-marginless">Puntuación {{top3[0].score}}</p>
                            <p class="has-text-centered"><small><b>{{top3[0].members}} Miembros</b></small></p>
                            <small>Maestro {{top3[0].master.name}}</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-12-mobile is-3 clickeable-box" v-if="top3.length > 1" @click="goToDetail(top3[1].name)">
                <div class="box has-text-grey">
                    <div class="media">
                        <div class="media-left">
                        <figure class="image is-48x48">
                            <fa icon="trophy" class="silver-color fa-3x"/>
                        </figure>
                        </div>
                        <div class="media-content has-text-centered is-clipped has-text-justified-mobile">
                            <p class="is-size-4-widescreen is-size-4-touch is-size-5-desktop has-text-grey is-marginless"><b>{{top3[1].name}}</b></p>
                            <p class="is-size-5 has-text-grey is-marginless">Puntuación {{top3[1].score}}</p>
                            <p class="has-text-centered"><small><b>{{top3[1].members}} Miembros</b></small></p>
                            <small>Maestro {{top3[1].master.name}}</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-12-mobile is-3 clickeable-box" v-if="top3.length > 2" @click="goToDetail(top3[2].name)">
                <div class="box has-text-grey">
                    <div class="media">
                        <div class="media-left">
                        <figure class="image is-32x32">
                            <fa icon="trophy" class="bronze-color fa-2x"/>
                        </figure>
                        </div>
                        <div class="media-content has-text-centered is-clipped has-text-justified-mobile">
                            <p class="is-size-5-widescreen is-size-4-touch has-text-grey is-size-5-desktop is-marginless"><b>{{top3[2].name}}</b></p>
                            <p class="is-size-6 is-size-5-touch has-text-grey is-marginless">Puntuación {{top3[2].score}}</p>
                            <p class="has-text-centered"><small><b>{{top3[2].members}} Miembros</b></small></p>
                            <small>Maestro {{top3[2].master.name}}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns is-vcentered is-centered" v-if="top10.length > 0">
            <div class="column is-2 is-12-mobile clickeable-box" v-for="(guild,n) in top10" :key="n" @click="goToDetail(guild.name)">
                <div class="box">
                    <span class="is-pulled-left">{{guild.position}}.</span>
                    <p class="has-text-justified-mobile"> <b>{{guild.name}}</b> </p>
                        Puntuación {{guild.score}} <br>
                        <small class="has-text-grey"><b>{{guild.members}} Miembros</b></small>
                        <br><small>Maestro {{guild.master.name}}</small>
                </div>
            </div>
        </div>
        <div class="card" v-if="top100.length > 0">
            <div class="card-content">
                <div class="table-container">
                    <table class="table is-responsive is-hoverable is-striped is-fullwidth">
                        <thead>
                            <tr>
                            <th>Nro.</th>
                            <th>Nombre</th>
                            <th>Puntuación</th>
                            <th>Maestro</th>
                            <th>Miembros</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(guild,n) in top100" :key="n" class="clickeable-box" @click="goToDetail(guild.name)">
                                <td>{{guild.position}}</td>
                                <td><b>{{guild.name}}</b></td>
                                <td>{{guild.score}}</td>
                                <td>{{guild.master.name}}</td>
                                <td>{{guild.members}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </div>
            </div>    
</div>

</template>

<script>
export default {
    name:'RankingGuilds',
    props: {
        top3: {
            type: Array,
            default: ()=>([])
        },
        top10: {
            type: Array,
            default: ()=>([])
        },
        top100: {
            type: Array,
            default: ()=>([])
        }
    },
    methods: {
        goToDetail(guild) {
            this.$router.push(`/gremios/${guild}`)
        }
    }
}
</script>

<style scoped>
    .table-container {
        overflow-x:auto !important;
    }
</style>